import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Council from "@/pages/Council";
import Portal from "@/pages/Portal";
import Guide from "@/pages/Guide";
import FilmPlayer from "@/pages/FilmPlayer";
import RewardProof from "@/pages/RewardProof";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import SmsProgram from "@/pages/SmsProgram";
import Poster from "@/pages/Poster";
import Guest from "@/pages/Guest";
import Wallet from "@/pages/Wallet";
import Register from "@/pages/Register";
import Shop from "@/pages/Shop";
import Growlab from "@/pages/Growlab";
import Vivarium from "@/pages/Vivarium";
import PayDior from "@/pages/PayDior";
import IvDLedger from "@/pages/IvDLedger";
import Story from "@/pages/Story";
import CovenantWallet from "@/pages/CovenantWallet";
import CovenantPeek from "@/pages/CovenantPeek";
import AssessmentRequest from "@/pages/AssessmentRequest";
import FamilyLetter from "@/pages/FamilyLetter";
import DirectorJalen from "@/pages/DirectorJalen";
import DirectorAharon from "@/pages/DirectorAharon";
import DirectorMiykha from "@/pages/DirectorMiykha";
import BourgExchange from "@/pages/BourgExchange";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/council" element={<Council />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/film" element={<FilmPlayer />} />
          <Route path="/reward" element={<RewardProof />} />
          <Route path="/poster" element={<Poster />} />
          <Route path="/guest" element={<Guest />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/sms-program" element={<SmsProgram />} />
          <Route path="/wallet" element={<Wallet />} />
          <Route path="/register" element={<Register />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/growlab" element={<Growlab />} />
          <Route path="/vivarium" element={<Vivarium />} />
          <Route path="/pay/diorsdough" element={<PayDior />} />
          <Route path="/ivd-ledger" element={<IvDLedger />} />
          <Route path="/story" element={<Story />} />
          <Route path="/covenant" element={<CovenantWallet />} />
          <Route path="/covenant/peek/:token" element={<CovenantPeek />} />
          <Route path="/assessment" element={<AssessmentRequest />} />
          <Route path="/letter" element={<FamilyLetter />} />
          <Route path="/directors/jalen-shepard" element={<DirectorJalen />} />
          <Route path="/directors/aharon-shepard" element={<DirectorAharon />} />
          <Route path="/directors/miykha-shepard" element={<DirectorMiykha />} />
          <Route path="/exchange" element={<BourgExchange />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
